export const CrmTriggerFieldLevelError = (
  errorFieldObject,
  errorsFromApi,
  triggerType
) => {
  const fieldMapping = {
    errorTriggerName: "triggerName",
    errorStatus: "status",
    errorStartDate: "startDate",
    errorEndDate: "endDate",
    errorMessageTemplate: "messageTemplate",
    errorIsSentViaLine: "isSentViaLine",
    errorIsSentViaSms: "isSentViaSms",
    errorMessageTemplateLine: "messageTemplateLine",
    errorMessageTemplateSms: "messageTemplateSms",
    errorMessageTemplatePushNoti: "messageTemplatePushNoti",
    errorProductParentCodes: "productParentCodes",
    errorMonthPeriod: "monthPeriod",
    errorAfterFirstBillDayPeriod: "afterFirstBillDayPeriod",
    errorIsWithPurchase: "isWithPurchase",
    errorIsWithoutPurchase: "isWithoutPurchase",
    errorByCategoriesMessageTemplates: "byCategoriesMessageTemplates",
    errorByMembershipMessageTemplates: "byMembershipMessageTemplate",
    errorHasTop40Products: "hasTop40Products",
    errorTop40ProductsFilePath: "top40ProductsFilePath",
    errorBillType: "billType",
    errorMonthNotPurchasePeriod: "monthNotPurchasePeriod",
    errorMinTotalPurchase: "minTotalPurchase",
    errorDaysAfterLastPurchase: "daysAfterLastPurchase",
    errorDaysAfterFirstBill: "daysAfterFirstBill",
    errorMessageTemplatesLineForHv: "messageTemplatesLineForHv",
    errorMessageTemplatesSmsForHv: "messageTemplatesSmsForHv",
    errorMessageTemplatesPushNotiForHv: "messageTemplatesPushNotiForHv",
    errorMessageTemplatesLineForLv: "messageTemplatesLineForLv",
    errorMessageTemplatesSmsForLv: "messageTemplatesSmsForLv",
    errorMessageTemplatesPushNotiForLv: "messageTemplatesPushNotiForLv",
    errorPurchaseSfsLx: "purchaseSfsLx",
    errorMinimumSpendingSfsLxHv: "minimumSpendingSfsLxHv",
    errorMessageTemplatesLineForSfsLxHv: "messageTemplatesLineForSfsLxHv",
    errorMessageTemplatesSmsForSfsLxHv: "messageTemplatesSmsForSfsLxHv",
    errorMessageTemplatesPushNotiForSfsLxHv:
      "messageTemplatesPushNotiForSfsLxHv",
    errorMinimumSpendingSfsLxLv: "minimumSpendingSfsLxLv",
    errorMessageTemplatesLineForSfsLxLv: "messageTemplatesLineForSfsLxLv",
    errorMessageTemplatesSmsForSfsLxLv: "messageTemplatesSmsForSfsLxLv",
    errorMessageTemplatesPushNotiForSfsLxLv:
      "messageTemplatesPushNotiForSfsLxLv",
    errorMinimumSpendingNonSfsLxHv: "minimumSpendingNonSfsLxHv",
    errorMessageTemplatesLineForNonSfsLxHv: "messageTemplatesLineForNonSfsLxHv",
    errorMessageTemplatesSmsForNonSfsLxHv: "messageTemplatesSmsForNonSfsLxHv",
    errorMessageTemplatesPushNotiForNonSfsLxHv:
      "messageTemplatesPushNotiForNonSfsLxHv",
    errorMinimumSpendingNonSfsLxLv: "minimumSpendingNonSfsLxLv",
    errorMessageTemplatesLineForNonSfsLxLv: "messageTemplatesLineForNonSfsLxLv",
    errorMessageTemplatesSmsForNonSfsLxLv: "messageTemplatesSmsForNonSfsLxLv",
    errorMessageTemplatesPushNotiForNonSfsLxLv:
      "messageTemplatesPushNotiForNonSfsLxLv",
    errorMessageTemplatesLineForAnyPurchase:
      "messageTemplatesLineForAnyPurchase",
    errorMessageTemplatesSmsForAnyPurchase: "messageTemplatesSmsForAnyPurchase",
    errorMessageTemplatesPushNotiForAnyPurchase:
      "messageTemplatesPushNotiForAnyPurchase",
  };

  const subStringNeededFields = [
    "errorVideoRelativePath",
    "errorPreviewImageRelativePath",
    "errorTargetUrl",
    "errorImageRelativePath",
    "errorPushNotiTargetUrl",
    "errorShowInInbox",
    "errorShowPeriodInDays",
    "errorMessageTitle",
    "errorMessageTemplatePushNoti",
  ];

  const arrayListFields = [
    "errorMessageTemplateSmsList",
    "errorMessageTemplateLineList",
    "errorMessageTemplatePushNotiList",
  ];

  for (const [errorKey, fieldName] of Object.entries(fieldMapping)) {
    errorFieldObject[errorKey] = errorsFromApi.find(
      (e) => e.fieldName === fieldName
    );
  }

  subStringNeededFields.forEach((errorKey) => {
    errorFieldObject[errorKey] = errorsFromApi.find((e) => {
      let errorFieldName = errorKey.slice(5);
      let errorFieldNameStartWithLowerCase =
        errorFieldName.charAt(0).toLowerCase() + errorFieldName.slice(1);
      return e.fieldName.startsWith(errorFieldNameStartWithLowerCase);
    });
  });

  if (triggerType === "NARS_TOUCH_2" || triggerType === "CPB BIRTHDAY") {
    arrayListFields.forEach((errorKey) => {
      errorFieldObject[errorKey] = errorsFromApi.filter((e) => {
        let errorFieldName = errorKey.slice(5, -4);
        let errorFieldNameStartWithLowerCase =
          errorFieldName.charAt(0).toLowerCase() + errorFieldName.slice(1);
        return e.fieldName.startsWith(errorFieldNameStartWithLowerCase);
      });
    });
  }
};
